import type { MoneyData, WebShopProductDetailsData } from '../../../app/data/model';
import { IEvent } from '../../../app/shared/EventAggregator';

export class WebShopProductViewedEvent implements IEvent {
  constructor(
    public readonly product: WebShopProductDetailsData,
    public readonly configurationCode: string,
    public readonly price: MoneyData,
    public readonly quantity: number,
  ) {}
}
